import React, { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import Image from "next/image";

export default function Filter({
  itemDropdown,
  selected,
  open,
  setOpen,
  handleOrder,
}) {
  return (
    <div className="z-20 flex w-full items-center justify-center space-x-2 rounded-full md:w-1/4">
      <Menu
        as="div"
        className={`relative flex h-11 w-full flex-col items-center justify-center rounded-xl bg-white p-2 shadow-[4px_4px_4px_0_rgba(0,0,0,0.05)] shadow-[#92A5C6]`}
      >
        <div className="flex w-full items-center justify-center">
          <Menu.Button
            className={`flex h-8 w-full items-center justify-between px-2`}
            onClick={() => setOpen(false)}
          >
            <p className="overflow-hidden text-ellipsis whitespace-nowrap font-nunito text-[#8F8F8F]">
              Sort by : <span className="text-black">{selected}</span>
            </p>
            <Image
              src="/images/dropdownhp.svg"
              alt="dropdownhp"
              width={20}
              height={10}
              priority={true}
            />
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items
            open={open}
            className={`absolute top-12 h-auto w-full cursor-pointer space-y-1 rounded-xl bg-white p-1 text-left`}
          >
            {itemDropdown.map((item, i) => (
              <Menu.Item
                as="div"
                onClick={() => handleOrder(item)}
                key={i}
                className="rounded-lg p-2 hover:bg-gray-100"
              >
                <p className="text-[#7F7F7F]">{item.text}</p>
              </Menu.Item>
            ))}
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}
